export enum EFeatureToggle {
  /*** Phoenix ***/
  /*** Lemur ***/
  ShowPolicyForInference = "release-23112-show-policy-for-inference",
  ShowFlatInference = "release-RUN-25482-show-flat-inference",
  ShowModelStoreInHuggingFace = "release-RUN-24954-show-model-store-in-hugging-face",
  ShowUpdateInference = "release-RUN-22084-show-update-inference",
  /*** Viper ***/
  ShowUpdateAssetEnabled = "release-23268-show-asset-editing",
  ShowMigProfilesDisabled = "release-19264-show-mig-profile-deprecation",
  ShowHybridSubmission = "release-19225-show-hybrid-submission-form",
  ShowDataVolume = "release-RUN-24483-show-datavolume",
  ShowHybridTemplates = "release-26413-show-templates-v2",
  /*** Suricata ***/
  QuotaManagementSectionV2 = "release-25024-show-quota-management-section-v2",
  ShowOverviewV2 = "release-24372-show-overview-v2",
  ShowNodesV2 = "release-RUN-19175-show-nodes-v2",
}
